<!-- Rebate Request - Measurement Committee - Review Rebate -->
<div *ngIf="!isRequestSucceeded">
    <!-- Form Title [Primary] -->
    <h2 class="sectionTitle">Measurement Committee - Review Rebate</h2>
    <!-- Rebate Request - Measurement Committee - View Valid Granted Rebate -->
    <app-rebate-request-define-rebate #defineRebate (optionSelected)="onOptionSelected($event)" (defineRebateLoadedFlag)="onDefineRebateLoadedFlag($event)"></app-rebate-request-define-rebate>
    <div class="form-container">
        <!-- [New - Edit] Mode -->
        <form name="form" #f="ngForm" style="width:100%;">
            <div *ngIf="isOptionSelected" class="form-section">
                <h4 class="section-title">Measurement Committee - Review Rebate</h4>
                <div *ngIf="selectedLongHaulRequestOption.ReviewRebateMode == 1 || selectedLongHaulRequestOption.ReviewRebateMode == 2" class="form-group">
                    <label>Decision</label>
                    <span class="red"> *</span>
                    <div class="form-custom-inputs">
                        <div class="custom-Radio">
                            <input type="radio" [(ngModel)]="selectedLongHaulRequestOption.RebatePercentageReviewDecision" id="rbtnRebateReviewDecisionAccept" name="RebateReviewDecision" value="true" (change)="onDecisionChange()" required #RebateReviewDecision="ngModel" />
                            <label for="rbtnRebateReviewDecisionAccept">Accept</label>
                        </div>
                        <div class="custom-Radio">
                            <input type="radio" [(ngModel)]="selectedLongHaulRequestOption.RebatePercentageReviewDecision" id="rbtnRebateReviewDecisionReject" name="RebateReviewDecision" value="false" (change)="onDecisionChange()" required #RebateReviewDecision="ngModel" />
                            <label for="rbtnRebateReviewDecisionReject">Reject</label>
                        </div>
                    </div>
                    <div *ngIf="isOptionSubmitted && RebateReviewDecision?.invalid" class="red">
                        <span *ngIf="RebateReviewDecision?.errors?.required">This Field is Required</span>
                    </div>
                </div>
                <div *ngIf="selectedLongHaulRequestOption.ReviewRebateMode == 3" class="form-group">
                    <label>Decision</label>
                    <label class="form-control">{{selectedLongHaulRequestOption.RebatePercentageReviewDecisionValue}}</label>
                </div>
                <div *ngIf="!isSelectedOptionRejected" class="form-group">
                    <label>Rejection Reason</label>
                    <span *ngIf="selectedLongHaulRequestOption.ReviewRebateMode != 3" class="red"> *</span>
                    <textarea type="text" [(ngModel)]="selectedLongHaulRequestOption.MeasurementCommiteeReviewRebateNotes" name="MeasurementCommiteeReviewRebateNotes" id="txtMeasurementCommiteeReviewRebateNotes" class="form-control" #MeasurementCommiteeReviewRebateNotes="ngModel" required></textarea>
                    <div *ngIf="isOptionSubmitted && MeasurementCommiteeReviewRebateNotes?.invalid" class="red">
                        <span *ngIf="MeasurementCommiteeReviewRebateNotes?.errors?.required">This Field is Required</span>
                    </div>
                </div>
            </div>
            <!-- Add Option Rebate Percentage Review Decision -->
            <p *ngIf="isOptionSelected && (selectedLongHaulRequestOption.ReviewRebateMode == 1 || selectedLongHaulRequestOption.ReviewRebateMode == 2)" class="btns-holder">
                <button type="button" class="btn SCAcustomBtn" (click)="isOptionSubmitted = true; f.form.valid && addOptionRebatePercentageReviewDecision()">Add Review Decision</button>
                <!-- <button type="button" class="btn SCAcustomBtn" (click)="cancelReviewingPercentage()">Cancel</button> -->
            </p>
        </form>
        <!-- <div *ngIf="isWorkFlowResponseReady" class="form-section">
            <h4 class="section-title">Measurement Committee Request Flow</h4>
            <div class="form-group">
                <label>Decision</label>
                <span class="red"> *</span>
                <div class="form-custom-inputs">
                    <div class="custom-Radio">
                        <input type="radio" [(ngModel)]="workFlowResponseDecision" id="rbtnWorkFlowResponseUpdate" name="WorkFlowResponse" value="false" (change)="onWorkFlowResponseChange()" #WorkFlowResponse="ngModel" required />
                        <label for="rbtnWorkFlowResponseUpdate">Update Request Rebate Percentages (By: Economic Committee)</label>
                    </div>
                    <div class="custom-Radio">
                        <input type="radio" [(ngModel)]="workFlowResponseDecision" id="rbtnWorkFlowResponseProceed" name="WorkFlowResponse" value="true" (change)="onWorkFlowResponseChange()" #WorkFlowResponse="ngModel" required />
                        <label for="rbtnWorkFlowResponseProceed">Proceed to Formulated Approved Decision (By: Economic Committee)</label>
                    </div>
                </div>
                <div *ngIf="isWorkFlowResponseNotValid && WorkFlowResponse?.invalid" class="red">
                    <span *ngIf="WorkFlowResponse?.errors?.required">This Field is Required</span>
                </div>
            </div>
        </div> -->
        <div *ngIf="isSubmitButtonDisplayed" class="form-group">
            <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="submit()">Submit</button>
            <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
        </div>
    </div>
</div>
<!-- Confirmation -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>You have submitted Rebate Request Review Rebate Successfully</p>
        <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
    </div>
</div>
<!-- Warning -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>This task was submitted before</p>
        <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
    </div>
</div>
<!-- Error -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
    </div>
</div>